import {
  f7,
} from 'framework7-vue';
import Request from './Request';
import EventBus from '../js/event-bus';

let username = '';
let token = '';
let refresh = '';
let headerAuth = {};

const agriFarm = '';
// const baseUrl = 'https://vegsyst.development.hispatecanalytics.com'; // Endpoint estable desarrollo
const baseUrl = 'https://vegsyst.hispatecanalytics.com'; // Endpoint producción

EventBus.$on('newLoggedUser', (payload) => {
  const data = JSON.parse(payload);
  username = data.username;
  token = data.token;
  refresh = data.refresh;
  headerAuth = `Bearer ${token}`;
});
EventBus.$on('setRefreshToken', (access) => {
  token = access;
  headerAuth = `Bearer ${token}`;
});

export default {

  errors: {
    default: {
      name: 'error',
      message: 'error',
      callback() {},
    },

    E002: {
      name: 'invalid_token',
      message: 'Su sesión ha expirado',

      callback() {
        if (!username) return;
        username = null;
        EventBus.$emit('invalidTokenDetected');
        f7.dialog.alert(this.message);
      },
    },
  },
  getToken() {
    return token;
  },
  getHeaderAuth() {
    return headerAuth;
  },
  getAgriFarm() {
    return agriFarm;
  },
  getTimeZone() {
    if (agriFarm === 'chile') return 'America/Santiago';
    if (agriFarm === 'serbia') return 'Europe/Madrid';
    return 'UTC';
  },
  getBaseUrl() {
    return baseUrl;
  },
  getRefreshToken() {
    return refresh;
  },
  // Login
  login(credentials) {
    const url = `${baseUrl}/user/authorization`;
    const payload = {
      data: JSON.stringify({
        email: credentials.email,
        password: credentials.password,
      }),
    };
    return Request.async(url, payload, 'POST', false, 'application/json')
      .then(this.handleLoginResult);
  },
  register(data) {
    const url = `${baseUrl}/user/register`;
    const payload = {
      data: JSON.stringify(data),
    };
    return Request.async(url, payload, 'POST', false, 'application/json')
      .then(this.handleLoginResult);
  },
  delete() {
    const url = `${baseUrl}/user/delete`;
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'DELETE', false, 'application/json', headerAuth)
      .then(this.handleLoginResult);
  },

  async handleLoginResult(result) {
    if (result.response !== '') {
      EventBus.$emit('resetData');
      EventBus.$emit('newLoggedUser', result.response);
    }
  },

  refreshToken() {
    const url = `${baseUrl}/user/refresh`;
    const payload = {
      data: JSON.stringify({ refresh }),
    };
    return Request.async(url, payload, 'POST', false, 'application/json', headerAuth);
  },

  getProfile() {
    const url = `${baseUrl}/profile`;
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'GET', false, 'application/json', headerAuth)
      .then(this.handleProfileResult);
  },
  async handleProfileResult(result) {
    if (result.response !== '') {
      EventBus.$emit('setProfileData', result.response);
    }
  },

  //  Auxiliary methods
  async request(url, payload, verb, processData, contentType) {
    const response = await Request.async(url, payload, verb, processData, contentType);
    return response;
  },

  getException(errorcode) {
    return errorcode in this.errors ? this.errors[errorcode] : this.errors.default;
  },
  // FETCH & GETS
  fetchListGround() {
    const url = `${baseUrl}/database/ground`;
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'GET', false, 'application/json', headerAuth);
  },
  fetchListCrop() {
    const url = `${baseUrl}/database/cultive`;
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'GET', false, 'application/json', headerAuth);
  },
  fetchListIrrigation() {
    const url = `${baseUrl}/database/irrigation`;
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'GET', false, 'application/json', headerAuth);
  },
  fetchListManure() {
    const url = `${baseUrl}/database/manure`;
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'GET', false, 'application/json', headerAuth);
  },
  fetchDatabaseTexture() {
    const url = `${baseUrl}/database/texture`;
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'GET', false, 'application/json', headerAuth);
  },
  fetchDatabaseFertilizers() {
    const url = `${baseUrl}/database/fertilizer`;
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'GET', false, 'application/json', headerAuth);
  },
  createDatabaseTexture(data) {
    const url = `${baseUrl}/database/texture`;
    const payload = {
      data: JSON.stringify(data),
    };
    return Request.async(url, payload, 'POST', false, 'application/json', headerAuth);
  },
  fetchDatabaseClimate(idProvince) {
    let url = `${baseUrl}/database/climate`;
    if (idProvince) {
      url = `${baseUrl}/database/climate?province=${idProvince}`;
    }
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'GET', true, 'application/json', headerAuth);
  },
  fetchDatabaseClimateSource(idSource) {
    const url = `${baseUrl}/database/climate/id/${idSource}`;
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'GET', true, 'application/json', headerAuth);
  },
  createDatabaseClimateSource(data) {
    const url = `${baseUrl}/database/climate`;
    const payload = {
      data,
    };
    return Request.async(url, payload, 'POST', true, 'multipart/form-data', headerAuth);
  },
  fetchDatabaseClimateSourceMeanYearGh() {
    const url = `${baseUrl}/database/climate/mean_year_gh`;
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'GET', true, 'application/json', headerAuth);
  },
  fetchDatabaseClimateSourceMeanYearEx() {
    const url = `${baseUrl}/database/climate/mean_year_ext`;
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'GET', true, 'application/json', headerAuth);
  },
  fetchDatabaseClimateSiar(data) {
    const url = `${baseUrl}/database/climate/siar`;
    const payload = {
      data,
    };
    return Request.async(url, payload, 'GET', true, 'application/json', headerAuth);
  },
  fetchProjects() {
    const url = `${baseUrl}/project`;
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'GET', false, 'application/json', headerAuth);
  },
  getProject(idProject) {
    const url = `${baseUrl}/project/${idProject}`;
    // const url = `${baseUrl}/project/6256de37766fd690f6a583ee`;

    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'GET', false, 'application/json', headerAuth);
  },
  fetchProvinces() {
    const url = `${baseUrl}/database/provinces`;
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'GET', false, 'application/json', headerAuth);
  },
  // POST:
  createNewProject(newProject) {
    const url = `${baseUrl}/project`;
    const payload = {
      data: JSON.stringify(newProject),
    };
    return Request.async(url, payload, 'POST', false, 'application/json', headerAuth);
  },
  updateProject(newProject, id) {
    const url = `${baseUrl}/project/${id}`;
    const payload = {
      data: JSON.stringify(newProject),
    };
    return Request.async(url, payload, 'PUT', false, 'application/json', headerAuth);
  },
  recalculateProject(data, id) {
    const url = `${baseUrl}/project/${id}/recalculate`;
    const payload = {
      data: JSON.stringify(data),
    };
    return Request.async(url, payload, 'POST', false, 'application/json', headerAuth);
  },
  // POST DATABASE
  createDatabaseGround(newGround) {
    const url = `${baseUrl}/database/ground`;
    const payload = {
      data: JSON.stringify(newGround),
    };
    return Request.async(url, payload, 'POST', false, 'application/json', headerAuth);
  },
  createDatabaseIrrigation(newIrrigation) {
    const url = `${baseUrl}/database/irrigation`;
    const payload = {
      data: JSON.stringify(newIrrigation),
    };
    return Request.async(url, payload, 'POST', false, 'application/json', headerAuth);
  },
  createDatabaseManure(newManure) {
    const url = `${baseUrl}/database/manure`;
    const payload = {
      data: JSON.stringify(newManure),
    };
    return Request.async(url, payload, 'POST', false, 'application/json', headerAuth);
  },
  createDatabaseFertilizer(data) {
    const url = `${baseUrl}/database/fertilizer`;
    const payload = {
      data: JSON.stringify(data),
    };
    return Request.async(url, payload, 'POST', false, 'application/json', headerAuth);
  },
  getResultProject(idProject) {
    const url = `${baseUrl}/project/${idProject}/result`;
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'GET', false, 'application/json', headerAuth);
  },
  deleteProject(idProject) {
    const url = `${baseUrl}/project/${idProject}`;
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'DELETE', false, 'application/json', headerAuth);
  },
  deleteTable(table, id) {
    const url = `${baseUrl}/database/${table}/${id}`;
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'DELETE', false, 'application/json', headerAuth);
  },
};
